<template>
  <b-row class="animated fadeIn">
    <b-col cols="12" col sm="12">
      <b-card>
         <div slot="header"><i class="fa fa-microchip"></i> Comprobantes Automáticos</div>
         <b-row class="mb-2">
           <b-col cols="12" class="text-center" v-show="isLoading && !busqueda_realizada">
             <loader-ag />
             <b-row>
               <p class="text-primary mx-auto">Por favor espere...</p>
             </b-row>
           </b-col>
          <b-col cols="12" col class="table-responsive">

          <b-table
                v-show="!isLoading"
                hover
                small
                show-empty
                empty-text="No hay registros para mostrar"
                responsive="sm"
                :items="items"
                :fields="fields"
                :per-page="perPage"
              >
            <template v-slot:cell(actions)="row">
              <b-button
              variant="outline-primary"
               @click="openModal(row.item)"
              >
                <i class="fa fa-eye"></i>
              </b-button>
            </template>
             </b-table>
          </b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="mt-4"
              @input="getRegistros"
            ></b-pagination>
          </b-row>
      </b-card>
    </b-col>

  <b-modal v-model="show" id="modal-lg" size="lg" :title="ModalTitle">
    <b-row>
    <b-col cols="8" col md="3">
      <b-form-group label="Fecha:">
        <date-picker
          :lang="lang"
          v-model="fechaSelect"
          format="YYYY-MM-DD"
          type="date"
          :clearable="false"
          :disabled-date="notAfterToday"
          style="width: 95%"
          value-type="YYYY-MM-DD"
        >
        </date-picker>
      </b-form-group>
    </b-col>
    <b-col cols="1" col md="1" class="mt-2">
      <br>
      <b-button
        size="sm"
        variant="outline-primary"
        v-b-tooltip.hover="'Buscar comprobante automático no registrado de la fecha indicada'"
        @click="getdetalleComprobante"
      >
        <i class="fa fa-search"></i>
      </b-button>
    </b-col>
    </b-row>
    <b-row class="text-center">
      <b-col cols="12" class="text-center" v-show="isLoading">
        <loader-ag />
        <b-row>
          <p class="text-primary mx-auto">Por favor espere...</p>
        </b-row>
      </b-col>
      <b-col cols="12" v-show="!isLoading && busqueda_realizada" class="table-responsive">

          <b-form-group :label="labelCajero" v-show="id==2 || id==3 || id ==6">
            <b-form-select
              id="cajero"
              v-model="rendicion_id"
              :options="rendiciones"
              class="mb-3"
              value-field="id"
              text-field="cajero"
              @change="getdetalleComprobante"
            ></b-form-select>
          </b-form-group>

        <p class="text-left" v-show="total_haber > 0" v-html="concepto"></p>
        <p class="text-right" v-show="total_haber > 0 && referencia">
          <i>Referencia: </i>  <a :href="referencia" target="_blank">{{referencia}}</a>
        </p>
        <table class="table table-condensed">
            <thead>
            <th class="negrita">Cuenta:</th>
            <th class="negrita">Descripción Cuenta:</th>
            <th class="negrita text-center">Debe:</th>
            <th class="negrita text-center">Haber:</th>
            </thead>
            <tbody>
            <tr v-for="(d, index) in detalleComprobante"  :key="index">
              <td>{{d.cuenta}}</td>
              <td>{{d.nombre}}</td>
              <td class="text-right">{{ d.debito |  currency('', 2, { thousandsSeparator: ',' }) }}</td>
              <td class="text-right">{{ d.credito |  currency('', 2, { thousandsSeparator: ',' }) }}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <td class="negrita text-right" colspan="2">Totales</td>
              <td class="negrita text-right">{{total_debe |  currency('', 2, { thousandsSeparator: ',' }) }}</td>
              <td class="negrita text-right">{{total_haber |  currency('', 2, { thousandsSeparator: ',' }) }}</td>
            </tr>
            </tfoot>
        </table>
      </b-col>
    </b-row>
    <b-row>

    </b-row>
    <template #modal-footer>
      <div class="w-100 text-right">
        <b-button
          variant="success"
          size="sm"
          class="mr-2"
          v-show="total_haber>0 && busqueda_realizada && no_click_guardar"
          @click="SaveComprobante"
        >
          <i class="fa fa-save"></i> Guardar
        </b-button>

        <b-button
          variant="primary"
          size="sm"
          class="pull-right"
          @click="show=false"
        >
         <i class="fa fa-sign-out"></i> Cerrar
        </b-button>
      </div>
    </template>


  </b-modal>

  </b-row>
</template>
<script>
const today = new Date();
import {debounce} from "lodash";
import { mapGetters } from "vuex";
import LoaderAg from "../../components/LoaderAg";
import toastr from "toastr";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";
import Vue2Filters from "vue2-filters";

export default {
  name: "comprobantes_automatico",
  mixins: [Vue2Filters.mixin],
  components: { DatePicker, LoaderAg },
  data: () => {
    return {
      no_click_guardar:true,
      id:undefined,
      fecha:undefined,
      tipo_cambio:0,
      concepto:'',
      concepto_original:'',
      referencia_original:'',
      referencia:'',
      rendiciones:[],
      rendicion_id:undefined,
      rendicion_id_original:undefined,
      show: false,
      ModalTitle:'',
      isLoading: false,
      busqueda_realizada:false,
      fechaSelect: undefined,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1
        }
      },
      items: [],
      fields: [
        { key: "nombre", sortable: true },
        {
          label: "",
          key: "actions",
          sortable: false
        }
        ],
      currentPage: 1,
      totalRows: 0,
      perPage: 15,
      model:{},
      detalleComprobante:[],
      total_debe:0,
      total_haber:0,

    };
  },
  mounted() {
this.getRegistros();
  },
  methods: {
    async SaveComprobante(){
      this.no_click_guardar = false;

      const {dismiss} = await this.$swal({
        title: "Desea Guardar?",
        html: `Esta segur@ que desea Guardar el Comprobante?`,
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Guardar",
        cancelButtonText: "Cancelar"
      });
      if (!dismiss) {
        try {
          this.model = {
            estado:0,
            anulado:0,
            empresa_id:this.empresaId,
            centro_id:this.empresaId,
            fecha: this.fecha,
            tasa_cambio:this.tipo_cambio,
            tipo_comprobante_id:1,
            moneda_id:1,
            enlace_referencia:this.referencia,
            concepto:this.concepto,
            total_debe: this.total_debe,
            total_haber: this.total_haber,
            total_debe_dol: this.total_debe / this.tipo_cambio,
            total_haber_dol: this.total_debe / this.tipo_cambio,
            detalles: this.detalleComprobante,
            comprobante_automatico:this.id
          }
          // eslint-disable-next-line no-undef
          const {status, data} = await axios.post("/api/comprobantes/store", {
            model: this.model,
            tipo: 1
          });
          if(status !== 200)
            return  toastr["error"]("Error algo paso en el backend 😯");

          if (data && data.errors) {
            toastr["error"]("🛑 No se puede Guardar."+JSON.stringify(data.errors));
            return;
          }


          if (data && data.status == "asentado") {
            toastr["error"](`🛑 No se puede Guardar. El mes de la fecha seleccionada <strong>ya fué cerrado</strong>, por tanto no puede hacer más comprobantes de ese mes`);
            return;
          }

          if (data && data.status == 'ok') {
            // eslint-disable-next-line no-undef
            let {status} = await axios.post('/api/reportes/data-comprobante',{id:this.id, fecha:this.fecha, preview:data.comprobante_id,  empresa_id: this.empresaId, rendicion_id: this.rendicion_id });
            if(status !== 200)
              return  toastr["error"]("Error algo paso en el backend a marcar como contabilizados los recibos de acopio 😯");

            this.detalleComprobante=[];
            this.busqueda_realizada = false;
            this.rendicion_id = null;
            toastr["success"]("Comprobante Guardado Correctamente");
          }



        }catch (error) {
          console.log(error);
        }
        this.detalleComprobante=[];
        this.total_haber=0;
        this.total_debe=0;
        this.referencia='';
        this.rendicion_id=undefined;

      }
      this.no_click_guardar = true;
    },
    async getdetalleComprobante(){

      if(!this.fecha)
        return toastr["warning"]("Favor agregue una fecha 😪");
      this.detalleComprobante=[];

      this.total_debe = 0;
      this.total_haber = 0;
      this.isLoading = true;
      this.busqueda_realizada = true;
      try {
        // eslint-disable-next-line no-undef
        let {status, data} = await axios.post('/api/reportes/data-comprobante',{
          id:this.id,
          fecha:this.fecha,
          preview:1,
          empresa_id: this.empresaId,
          rendicion_id:this.rendicion_id
        });
        if(status !== 200){
          this.isLoading =false;
          this.rendicion_id = null;
          return  toastr["error"]("Error algo paso en el backend 😯");
        }

        if(this.id ==2 && data && data.datos[0] && data.datos[0].anterior){
          this.isLoading =false;
          this.rendicion_id = null;
          this.detalleComprobante=[];
          return  toastr["error"](`Existe una rendicion anterior del cajero seleccionado del día: ${data.datos[0].anterior} primero se debe registrar esa rendición`);
        }

        let rendicion_seleccionada=null;
        this.isLoading = false;
        if(data.status =='fail'){
          this.rendicion_id = null;
          return  toastr["error"](JSON.stringify(data.errors));
        }

        this.rendiciones = data.rendiciones ? data.rendiciones : [];

        if(this.rendicion_id){
          rendicion_seleccionada = this.rendiciones.filter(rendicion => parseInt(rendicion.id) == parseInt(this.rendicion_id));
        }
        console.log("la rendicion seleccionada es");
        console.log(rendicion_seleccionada);

        this.detalleComprobante = data.datos ? data.datos : [];

        this.detalleComprobante.forEach(d=>{
          this.total_debe += parseFloat(d.debito);
          this.total_haber += parseFloat(d.credito);
          d.cuenta = d.cuenta.toString();
        });

        if(parseFloat(this.total_haber)>0) {
          this.referencia = this.referencia_original;
          this.concepto = this.concepto_original;
          this.tipo_cambio = this.detalleComprobante[0].tasa_cambio;

          if(this.fecha && this.referencia)
            this.referencia = this.referencia.replace('{{fecha}}',this.fecha);

          if(rendicion_seleccionada && rendicion_seleccionada[0].sucursal_id)
            this.referencia = this.referencia.replace('{{sucursal_id}}', rendicion_seleccionada[0].sucursal_id);

          if(rendicion_seleccionada && rendicion_seleccionada[0].agencia && this.concepto){
            console.log("entro al replace el concepto era ", this.concepto_original);
            this.concepto = this.concepto.replace('{{agencia}}', rendicion_seleccionada[0].agencia);
            console.log("concepto ahora ", this.concepto);
          }

          if(this.fecha && this.concepto)
          this.concepto = this.concepto.replace('{{fecha}}',this.fecha);

          if(this.detalleComprobante && this.detalleComprobante[0].qq && this.concepto)
          this.concepto = this.concepto.replace('{{qq}}', this.detalleComprobante[0].qq);


          if(this.rendicion_id && this.referencia)
          this.referencia = this.referencia.replace('{{rendicion_id}}', this.rendicion_id);


          console.log("la referencia es ", this.referencia);
        }

      }catch (error) {
        console.log(error);
      }
    },
    cambiarFormatoFecha(date) {
      // eslint-disable-next-line no-undef
      this.fecha = moment(date).format("YYYY-MM-DD");
    },
    openModal(item){
      this.ModalTitle = item.nombre;
      this.id = item.id;
      this.concepto='';
      this.referencia='';
      this.concepto_original=item.concepto;
      this.concepto=item.concepto;
      this.referencia_original=item.referencia;
      this.referencia=item.referencia;
      this.detalleComprobante=[];
      this.fechaSelect=undefined;
      this.fecha=undefined;
      this.show=true;
    },
    async getRegistros() {
      this.isLoading = true;
      this.totalRows =0;
      this.items = [];

      try {
        // eslint-disable-next-line no-undef
        let {data} = await axios.post("/api/catalogos/lista-comprobantes-automaticos", {
          perPage: this.perPage,
          currentPage: this.currentPage,
          empresa_id: this.empresaId,
        });
        this.totalRows = data.total;
        this.items = data.data;

        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    notAfterToday(date) {
      return date > today;
    }
  },
  computed: {
    ...mapGetters("authentication", ["empresaId"]),
    labelCajero(){
      if(this.id == 2) return "Seleccione Rendición / Cajero";
      if(this.id == 3) return "Seleccione Agencia / Cajero";
    }
  },
  watch: {
    fechaSelect: debounce(function(date) {
      this.detalleComprobante=[];
      this.busqueda_realizada = false;
      this.rendicion_id = null;
      this.cambiarFormatoFecha(date);
    }, 30)
  }

};
</script>
<style scoped>

</style>
